<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
      <b-button-toolbar class="mr-3 float-right">
        <b-form-radio-group id="radiosBtn" buttons button-variant="outline-secondary" v-model="statisticsTimeInterval" name="radiosBtn">
          <b-form-radio class="mx-0" value="Day" >Last 30 Days</b-form-radio>
          <b-form-radio class="mx-0" value="Month" >Month</b-form-radio>
          <b-form-radio class="mx-0" value="Quarter">Quarter</b-form-radio>
          <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
        </b-form-radio-group>
        <date-range-picker
          ref="picker"
          opens="left"
          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
          :maxDate="new Date()"
          singleDatePicker="range"
          :timePicker="false"
          :timePicker24Hour="false"
          :showWeekNumbers="false"
          :showDropdowns="true"
          :autoApply="false"
          v-model="customDateRange"
          :ranges="false"
          @select="handleSelect"
        >
          <template #header>
            <div class="date-range-picker__header">
              <b-form-group
                label="Start Date:"
                label-for="startDate"
                label-size="sm"
                class="mb-0"
              >
                <b-form-input
                  class="mb-0"
                  data-vv-name="startDate"
                  data-vv-as="startDate"
                  id="startDate"
                  size="sm"
                  type='text'
                  name="startDate"
                  v-model="customDateRange.startDate"
                />
              </b-form-group>
              <b-form-group
                label="End Date:"
                label-for="endDate"
                label-size="sm"
                class="mb-0"
              >
                <b-form-input
                  class="mb-0"
                  data-vv-name="endDate"
                  data-vv-as="endDate"
                  id="endDate"
                  size="sm"
                  type='text'
                  name="endDate"
                  v-model="customDateRange.endDate"
                />
              </b-form-group>
            </div>
          </template>
          <template v-slot:input style="min-width: 350px;">
            <b-button :class="['mx-0', { 'active': statisticsTimeInterval === 'Custom' }]" variant="outline-secondary">
              Custom
            </b-button>
          </template>
          <template v-slot:footer="picker">
            <div class="date-range-picker__footer">
              <b-button type="button" @click="saveCustomDateRange(picker.clickApply)" variant="outline-primary">
                Save
              </b-button>
            </div>
          </template>
        </date-range-picker>
        <b-form-radio button class="mx-0" v-model="statisticsTimeInterval" button-variant="outline-secondary" value="All" >All</b-form-radio>
      </b-button-toolbar>
      </b-col>
    </b-row>
    <b-tabs v-model="tabIndex" id="statistics-tabs">
      <b-tab title="Overall Demographics">
        <b-row>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ generalCounts.personCount === null ? 0 : generalCounts.personCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">All People</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToConfirmed">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.confirmedPersonCount === null ? 0 : generalCounts.confirmedPersonCount }} </span>
                  <span class="text-muted">({{ percentConfirmedPersons }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Confirmed Victims</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToBlankConfirmed">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.possiblePersonCount === null ? 0 : generalCounts.possiblePersonCount }} </span>
                  <span class="text-muted">({{ percentUnconfirmedPersons }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>

              <small class="text-muted text-uppercase font-weight-bold">Others</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Persons By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">People over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="personsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height="200"
            chartName="People"
            :apiData="personCountsByTime"
            v-if="!personCountsByTimeError"
          >
          </main-chart>
          <p v-if="personCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='demographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="personCountsByDemographicError">There is no data for this chart.</p>
            <b-row v-if="!personCountsByDemographicError">
              <b-col sm="4">
                <h4 class="text-center">All People</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Total People"
                  :apiData="personCountsByDemographic"
                  valueField="personCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Confirmed Victims</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Confirmed Victims"
                  :apiData="personCountsByDemographic"
                  valueField="confirmedVictimCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Others</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Possible Victims"
                  :apiData="personCountsByDemographic"
                  valueField="possibleVictimCount"
                  :groupedBy="demographicField"
                ></pie-chart>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='demographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="demographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <!-- STACKED LINE CHARTS -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All People</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="personDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!personDemographicsByTimeError"
                ></stacked-line-chart>
                <p v-if="personDemographicsByTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Confirmed Victims</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="personDemographicsByTimeConfirmed"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!personDemographicsOverTimeConfirmedError"
                ></stacked-line-chart>
                <p v-if="personDemographicsOverTimeConfirmedError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Others</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="personDemographicsByTimeUnconfirmed"
                  valueField="timeInterval"
                  :demographicName="demographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!personDemographicsOverTimeUnconfirmedError"
                ></stacked-line-chart>
                <p v-if="personDemographicsOverTimeUnconfirmedError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
      </b-tab>
      <b-tab title="CSE-IT">
        <b-row>
          <b-col sm="12" md="12" v-if="isManager">
            <download-csv :data="formattedScreeningsByOrg" name="screenings.csv">
              <b-btn class="float-right" variant="primary" style="margin-right: 5px; margin-bottom: 10px;">Download Screenings by Concern Level</b-btn>
            </download-csv>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ generalCounts.cseitCount === null ? 0 : generalCounts.cseitCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-note"></i>
              </div>
              <div class="h1 mb-0"> {{ generalCounts.cseitCount === null ? 0 : generalCounts.cseitCount }} </div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">CSE-IT Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.cseitCountAllPerson === null ? 0 : generalCounts.cseitCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToNoConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.cseitCountNoConcern === null ? 0 : generalCounts.cseitCountNoConcern }} </span>
                  <span class="text-muted">({{ percentCseitNoconcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountNoConcern === null ? 0 : generalCounts.cseitCountNoConcern }} </span><span class="text-muted">({{ percentCseitNoconcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">No Concern</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.cseitCountNoConcernPerson === null ? 0 : generalCounts.cseitCountNoConcernPerson }} unique person(s)</small>
              <br>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning clickable-card" @click="goToPossibleConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.cseitCountPossibleConcern === null ? 0 : generalCounts.cseitCountPossibleConcern }} </span>
                  <span class="text-muted">({{ percentCseitPossibleConcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountPossibleConcern === null ? 0 : generalCounts.cseitCountPossibleConcern }} </span><span class="text-muted">({{ percentCseitPossibleConcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">Possible Concern</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.cseitCountPossibleConcernPerson === null ? 0 : generalCounts.cseitCountPossibleConcernPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToClearConcern">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.cseitCountClearConcern === null ? 0 : generalCounts.cseitCountClearConcern }} </span>
                  <span class="text-muted">({{ percentCseitClearConcern }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <!--
              <div class="h1 text-muted text-right mb-4">
                <i class="icon-pie-chart"></i>
              </div>
              <div><span class="h1 mb-0"> {{ generalCounts.cseitCountClearConcern === null ? 0 : generalCounts.cseitCountClearConcern }} </span><span class="text-muted">({{ percentCseitClearConcern }}%)</span></div>
              -->
              <small class="text-muted text-uppercase font-weight-bold">Clear Concern</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.cseitCountClearConcernPerson === null ? 0 : generalCounts.cseitCountClearConcernPerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Screenings Table for Primary Org -->
        <b-col sm="12" md="12" v-if="isManager && screeningsByPrimaryOrg.length">
          <b-table
            sticky-header="350px"
            :striped="true"
            :bordered="false"
            :small="true"
            :fixed="true"
            responsive="sm"
            :items="screeningsByPrimaryOrg"
            :fields="screeningsTableFields"
          >
            <template v-if="totalScreeningRow" slot="bottom-row" slot-scope="data">
              <td :key="i" v-for="(field, i) in data.fields">
                  {{ totalScreeningRow[field.key] }}
              </td>
            </template>
          </b-table>
        </b-col>
        <!-- CSE-IT By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Screenings over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height=200
            chartName="Screenings"
            :apiData="cseitCountsByTime"
            v-if="!cseitCountsByTimeError"
          >
          </main-chart>
          <p v-if="cseitCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='cseitDemographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='cseitDemographic'
                v-model='cseitDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="cseitCountsByDemographicError">There is no data for this chart.</p>
            <div v-else>
              <b-row>
                <b-col sm="6">
                  <h4 class="text-center">All Screenings</h4>
                  <pie-chart
                    chartName="Screenings"
                    :apiData="cseitCountsByDemographic"
                    valueField="cseitCount"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6">
                  <h4 class="text-center">No Concern</h4>
                  <pie-chart
                    chartName="No Concern"
                    :apiData="cseitCountsByDemographic"
                    valueField="cseitCountNoConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <h4 class="text-center">Possible Concern</h4>
                  <pie-chart
                    chartName="Possible Concern"
                    :apiData="cseitCountsByDemographic"
                    valueField="cseitCountPossibleConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6">
                  <h4 class="text-center">Clear Concern</h4>
                  <pie-chart
                    chartName="Clear Concern"
                    :apiData="cseitCountsByDemographic"
                    valueField="cseitCountClearConcern"
                    :groupedBy="cseitDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
            </div>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='cseitDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="cseitDemographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <!-- Stacked Line Charts -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Screenings</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="cseitDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!cseitDemographicsByTimeError"
                ></stacked-line-chart>
                <p v-if="cseitDemographicsByTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">No Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="cseitDemographicsByTimeNoConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!cseitDemographicsOverTimeNoConcernError"
                ></stacked-line-chart>
                <p v-if="cseitDemographicsOverTimeNoConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Possible Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="cseitDemographicsByTimePossibleConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!cseitDemographicsOverTimePossibleConcernError"
                ></stacked-line-chart>
                <p v-if="cseitDemographicsOverTimePossibleConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
              <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Clear Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="cseitDemographicsByTimeClearConcern"
                  valueField="timeInterval"
                  :demographicName="cseitDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!cseitDemographicsOverTimeClearConcernError"
                ></stacked-line-chart>
                <p v-if="cseitDemographicsOverTimeClearConcernError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="cseitIndicatorOptions"
                  id='demographic'
                  v-model='cseitIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="cseitIndicators"
                v-if="!cseitIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="cseitIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="Lighthouse Indicators">
        <b-row>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ generalCounts.assessmentCount === null ? 0 : generalCounts.assessmentCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">All Lighthouse Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.assessmentCountAllPerson === null ? 0 : generalCounts.assessmentCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card>
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.assessmentCountNotEnoughInfo  === null ? 0 : generalCounts.assessmentCountNotEnoughInfo }} </span>
                  <span class="text-muted">({{ percentAssessmentNotenoughinfo }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"><i class="icon-pie-chart"></i></div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Not Enough Info</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.assessmentCountNotEnoughInfoPerson === null ? 0 : generalCounts.assessmentCountNotEnoughInfoPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.assessmentCountPossible === null ? 0 : generalCounts.assessmentCountPossible }} </span>
                  <span class="text-muted">({{ percentAssessmentPossible }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"><i class="icon-pie-chart"></i></div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Possible Victim</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.assessmentCountPossiblePerson === null ? 0 : generalCounts.assessmentCountPossiblePerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Assessments By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Lighthouse Screenings over Time</h4>
              <hr>
              <!--
              <b-button-toolbar class="float-left">
                <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentsTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
              -->
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height="200"
            chartName="Assessments"
            :apiData="assessmentCountsByTime"
            v-if="!assessmentCountsByTimeError"
          >
          </main-chart>
          <p v-if="assessmentCountsByTimeError">There is no data for this chart.</p>
        </b-card>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='demographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='demographic'
                v-model='assessmentDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="assessmentByDemographicError">There is no data for this chart.</p>
            <b-row v-if="!assessmentByDemographicError">
              <b-col sm="4">
                <h4 class="text-center">All Lighthouse Screenings</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Total People"
                  :apiData="assessmentCountsByDemographic"
                  valueField="assessmentCount"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Not Enough Information</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Possible Victims"
                  :apiData="assessmentCountsByDemographic"
                  valueField="assessmentCountNotEnoughInfo"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
              <b-col sm="4">
                <h4 class="text-center">Possible Victim</h4>
                <pie-chart
                  class="chart-wrapper"
                  chartName="Confirmed Victims"
                  :apiData="assessmentCountsByDemographic"
                  valueField="assessmentCountPossible"
                  :groupedBy="assessmentDemographicField"
                ></pie-chart>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='assessmentDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <!--
                <b-button-toolbar class="float-right">
                  <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="assessmentDemographicByTimeInterval" name="radiosBtn">
                  <b-form-radio v-if="!hideDayGraphFilter" class="mx-0" value="Day" >Last 30 Days</b-form-radio>
                  <b-form-radio v-if="!hideMonthGraphFilter" class="mx-0" value="All" >Month</b-form-radio>
                  </b-form-radio-group>
                </b-button-toolbar>
                -->
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Lighthouse Screenings</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="assessmentDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!assessmentDemographicsByTimeError"
                ></stacked-line-chart>
                <p v-if="assessmentDemographicsByTimeError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Not Enough Information</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="assessmentDemographicsByTimeNoInfoVictims"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!assessmentDemographicsOverTimeNoInfoError"
                ></stacked-line-chart>
                <p v-if="assessmentDemographicsOverTimeNoInfoError">There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Possible Victim</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="assessmentDemographicsByTimePossibleVictims"
                  valueField="timeInterval"
                  :demographicName="assessmentDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!assessmentDemographicsOverTimePossibleError"
                ></stacked-line-chart>
                <p v-if="assessmentDemographicsOverTimePossibleError">There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="assmentIndicatorOptions"
                  id='demographic'
                  v-model='assessmentIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <horizontal-bar-chart
                :apiData="assessmentIndicators"
                v-if="!assessmentIndicatorsError"
              >
              </horizontal-bar-chart>
              <p v-if="assessmentIndicatorsError">There is no data for this chart.</p>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab
        v-if="isUserInLA"
        title="Labor Screening"
      >
        <b-row>
          <b-col sm="12" md="12" v-if="isManager">
            <download-csv :data="formattedLaborScreeningsByOrg" name="screenings.csv">
              <b-btn class="float-right" variant="primary" style="margin-right: 5px; margin-bottom: 10px;">Download Screenings by Conclusion</b-btn>
            </download-csv>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-info">
              <b-row>
                <b-col>
                  <div class="h1 mb-0"> {{ generalCounts.lsCount }} </div>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-note"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Labor Screenings</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.lsCountAllPerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="clickable-card" @click="goToLSNotEnoughInfo">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.lsCountNotEnoughInfo }} </span>
                  <span class="text-muted">({{ percentLsNotEnoughInfo }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Not Enough Info</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.lsCountNotEnoughInfoPerson }} unique person(s)</small>
              <br>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-warning clickable-card" @click="goToLSVulnerable">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.lsCountVulnerable }} </span>
                  <span class="text-muted">({{ percentLsVulnerable }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Level 1: Concern</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.lsCountVulnerablePerson }} unique person(s)</small>
            </b-card>
          </b-col>
          <b-col sm="12" md="3">
            <b-card class="text-white bg-danger clickable-card" @click="goToLSHighlyVulnerable">
              <b-row>
                <b-col>
                  <span class="h1 mb-0"> {{ generalCounts.lsCountHighlyVulnerable }} </span>
                  <span class="text-muted">({{ percentLsHighlyVulnerable }}%)</span>
                </b-col>
                <b-col>
                  <div class="h1 text-muted text-right mb-4"> <i class="icon-pie-chart"></i> </div>
                </b-col>
              </b-row>
              <small class="text-muted text-uppercase font-weight-bold">Level 2: Indicated</small>
              <br><small class="text-muted text-uppercase"> {{ generalCounts.lsCountHighlyVulnerablePerson }} unique person(s)</small>
            </b-card>
          </b-col>
        </b-row>
        <!-- Screenings Table for Primary Org -->
        <b-col sm="12" md="12" v-if="isManager && laborScreeningsByPrimaryOrg.length">
          <b-table
            sticky-header="350px"
            :striped="true"
            :bordered="false"
            :small="true"
            :fixed="true"
            responsive="sm"
            :items="laborScreeningsByPrimaryOrg"
            :fields="laborScreeningsTableFields"
          >
            <template v-if="totalLaborScreeningRow" slot="bottom-row" slot-scope="data">
              <td :key="i" v-for="(field, i) in data.fields">
                  {{ totalLaborScreeningRow[field.key] }}
              </td>
            </template>
          </b-table>
        </b-col>
         <!-- Labor Screenings By Time -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Screenings over Time</h4>
              <hr>
            </b-col>
          </b-row>
          <main-chart
            class="chart-wrapper"
            style="height:200px;margin-top:40px;"
            height=200
            chartName="Screenings"
            :apiData="lsCountsByTime"
            v-if="!lsCountsByTimeError"
          />
          <p v-else>There is no data for this chart.</p>
        </b-card>
        <!-- Labor Screenings By Demographic Status -->
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
              <b-col>
                <h4 class="card-title mb-0">Demographics by Status</h4>
                <hr/>
              </b-col>
            </b-row>
            <b-form-group
              label-size='lg'
              label-text-align="left"
              label-class='addpersonlabel'
              label='Group By'
              label-for='lsDemographic'
              horizontal
              style="width:400px"
            >
              <b-form-select
                size="lg"
                :options="biographicOptions"
                id='lsDemographic'
                v-model='laborScreeningDemographicField'
              >
              </b-form-select>
            </b-form-group>
            <p v-if="lsCountsByDemographicError">There is no data for this chart.</p>
            <div v-else>
              <b-row>
                <b-col sm="6">
                  <h4 class="text-center">All Screenings</h4>
                  <pie-chart
                    chartName="Screenings"
                    :apiData="lsCountsByDemographic"
                    valueField="lsCount"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6">
                  <h4 class="text-center">Not Enough Info</h4>
                  <pie-chart
                    chartName="Not Enough Info"
                    :apiData="lsCountsByDemographic"
                    valueField="lsCountNotEnoughInfo"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <h4 class="text-center">Level 1: Concern</h4>
                  <pie-chart
                    chartName="Level 1: Concern"
                    :apiData="lsCountsByDemographic"
                    valueField="lsCountVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
                <b-col sm="6">
                  <h4 class="text-center">Level 2: Indicated</h4>
                  <pie-chart
                    chartName="Level 2: Indicated"
                    :apiData="lsCountsByDemographic"
                    valueField="lsCountHighlyVulnerable"
                    :groupedBy="laborScreeningDemographicField"
                  ></pie-chart>
                </b-col>
              </b-row>
            </div>
         </b-card>
        </b-card-group>
        <!-- Labor Screenings By Demographics Over Time -->
        <b-card-group class="card-columns">
          <b-card>
            <b-row>
                <b-col>
                  <h4 class="card-title mb-0">Demographics over Time</h4>
                  <hr/>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label-size='lg'
                  label-text-align="left"
                  label-class='addpersonlabel'
                  label='Group By'
                  label-for='demographic'
                  horizontal
                  style="width:400px"
                >
                  <b-form-select
                    size="lg"
                    :options="biographicOptions"
                    id='demographic'
                    v-model='lsDemographicByTimeField'
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Stacked Line Charts -->
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">All Screenings</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="lsDemographicsByTime"
                  valueField="timeInterval"
                  :demographicName="lsDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!lsDemographicsByTimeError"
                />
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Not Enough Info</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="lsDemographicsByTime"
                  valueField="timeInterval"
                  demographicTotalKey="demographicNotEnoughInfo"
                  :demographicName="lsDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!lsDemographicsByTimeError"
                />
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Level 1: Concern</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="lsDemographicsByTime"
                  valueField="timeInterval"
                  demographicTotalKey="demographicVulnerable"
                  :demographicName="lsDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!lsDemographicsByTimeError"
                />
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
              <b-row>
              <b-col sm="12">
                <h4 class="card-title mb-0">Level 2: Indicated</h4>
                <stacked-line-chart
                  class="chart-wrapper"
                  style="height:200px;margin-top:40px;"
                  height="200"
                  chartName="Demographics over Time"
                  :apiData="lsDemographicsByTime"
                  valueField="timeInterval"
                  demographicTotalKey="demographicHighlyVulnerable"
                  :demographicName="lsDemographicByTimeField"
                  :colorValues="colorValues"
                  v-if="!lsDemographicsByTimeError"
                />
                <p v-else>There is no data for this chart.</p>
              </b-col>
            </b-row>
         </b-card>
        </b-card-group>
        <!-- Indicators -->
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">Indicators</h4>
              <hr>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
              <b-form-group
                label-for='demographic'
                horizontal
                style="width:400px"
              >
                <b-form-select
                  size="lg"
                  :options="laborScreeningIndicatorOptions"
                  id='demographic'
                  v-model='laborScreeningIndicatorOption'
                >
                </b-form-select>
              </b-form-group>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-tabs>
                <b-tab title="Ends">
                  <horizontal-bar-chart
                    v-if="!lsIndicatorsError"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="laborScreeningIndicatorsEnds"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Means">
                  <horizontal-bar-chart
                    v-if="!lsIndicatorsError"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="laborScreeningIndicatorsMeans"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
                <b-tab title="Process">
                  <horizontal-bar-chart
                    v-if="!lsIndicatorsError"
                    :transformKeyFunction="transformLaborScreeningIndicatorKey"
                    :apiData="laborScreeningIndicatorsProcess"
                  />
                  <p v-else>There is no data for this chart.</p>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import HorizontalBarChart from '../charts/HorizontalBarChart'
import MainChart from '../charts/MainChart'
import PieChart from '../charts/PieChart'
// import StackedBarChart from '../charts/StackedBarChart'
import StackedLineChart from '../charts/StackedLineChart'
import JsonCSV from 'vue-json-csv'
import AssessmentIndicatorsTile from '../charts/AssessmentIndicators'
import AssessmentIndicatorsComparison from '../charts/AssessmentIndicatorsComparison'
import { LABOR_SCREENING_CONCLUSION, STATISTICS_TAB_INDEX } from '../../helpers/enums'

import { mapGetters } from 'vuex'
import userStateMixin from '@/mixins/userState.js'

export default {
  name: 'statistics',
  mixins: [userStateMixin],
  components: {
    HorizontalBarChart,
    MainChart,
    PieChart,
    AssessmentIndicatorsTile,
    AssessmentIndicatorsComparison,
    // StackedBarChart,
    StackedLineChart,
    'download-csv': JsonCSV
  },
  computed: {
    ...mapGetters({
      assessmentIndicators: 'getAssessmentIndicators',
      assessmentIndicatorsByPerson: 'getAssessmentIndicatorsByPerson',
      generalCounts: 'getGeneralCounts',
      assessmentCountsByTime: 'getAssessmentCountsByTime',
      personCountsByTime: 'getPersonCountsByTime',
      personCountsByDemographic: 'getPersonCountsByDemographic',
      cseitCountsByIndicators: 'getCseitCountsByIndicators',
      assessmentFields: 'getAssessmentFields',
      biographicOptions: 'getPersonBiographicOptions',
      assmentIndicatorOptions: 'getAssessmentIndicatorOptions',
      userCurrentContext: 'userCurrentContext',
      cseitCountsByTime: 'getCseitCountsByTime',
      lsCountsByTime: 'getLaborScreeningCountsByTime',
      lsCountsByTimeError: 'getLaborScreeningCountsByTimeError',
      personDemographicsByTime: 'getPersonDemographicsByTime',
      personDemographicsByTimeUnconfirmed: 'getPersonDemographicsByTimeUnconfirmed',
      personDemographicsByTimeConfirmed: 'getPersonDemographicsByTimeConfirmed',
      cseitCountsByDemographic: 'getCseitCountsByDemographic',
      lsCountsByDemographic: 'getLaborScreeningCountsByDemographic',
      lsCountsByDemographicError: 'getLaborScreeningCountsByDemographicError',
      assessmentCountsByDemographic: 'getAssessmentCountsByDemographic',
      cseitDemographicsByTime: 'getCseitDemographicsByTime',
      cseitDemographicsByTimeNoConcern: 'getCseitDemographicsByTimeNoConcern',
      cseitDemographicsByTimePossibleConcern: 'getCseitDemographicsByTimePossibleConcern',
      cseitDemographicsByTimeClearConcern: 'getCseitDemographicsByTimeClearConcern',
      lsDemographicsByTime: 'getLaborScreeningDemographicsByTime',
      lsDemographicByTimeError: 'getLaborScreeningDemographicsByTimeError',
      assessmentDemographicsByTime: 'getAssessmentDemographicsByTime',
      assessmentDemographicsByTimeNoInfoVictims: 'getAssessmentDemographicsByTimeNoInfoVictims',
      assessmentDemographicsByTimePossibleVictims: 'getAssessmentDemographicsByTimePossibleVictims',
      cseitIndicators: 'getCseitIndicators',
      cseitIndicatorOptions: 'getCseitIndicatorOptions',
      colorValues: 'getColorValues',
      personDemographicsByTimeError: 'getPersonDemographicsByTimeError',
      personCountsByTimeError: 'getPersonCountsByTimeError',
      personCountsByDemographicError: 'getPersonCountsByDemographicError',
      personDemographicsOverTimeUnconfirmedError: 'getPersonDemographicsOverTimeUnconfirmedError',
      personDemographicsOverTimeConfirmedError: 'getPersonDemographicsOverTimeConfirmedError',
      cseitCountsByTimeError: 'getCseitCountsByTimeError',
      cseitCountsByDemographicError: 'getCseitCountsByDemographicError',
      cseitDemographicsByTimeError: 'getCseitDemographicsByTimeError',
      cseitDemographicsOverTimeNoConcernError: 'getCseitDemographicsOverTimeNoConcernError',
      cseitDemographicsOverTimePossibleConcernError: 'getCseitDemographicsOverTimePossibleConcernError',
      cseitDemographicsOverTimeClearConcernError: 'getCseitDemographicsOverTimeClearConcernError',
      assessmentCountsByTimeError: 'getAssessmentCountsByTimeError',
      assessmentByDemographicError: 'getAssessmentByDemographicError',
      assessmentDemographicsByTimeError: 'getAssessmentDemographicsByTimeError',
      assessmentDemographicsOverTimeNoInfoError: 'getAssessmentDemographicsOverTimeNoInfoError',
      assessmentDemographicsOverTimePossibleError: 'getAssessmentDemographicsOverTimePossibleError',
      assessmentIndicatorsError: 'getAssessmentIndicatorsError',
      cseitIndicatorsError: 'getCseitIndicatorsError',
      laborScreeningIndicatorOptions: 'getLaborScreeningIndicatorOptions',
      lsIndicatorsError: 'getLaborScreeningIndicatorsError',
      lsIndicators: 'getLaborScreeningIndicators',
      statisticsScreeningsByOrg: 'getStatisticsScreeningsByOrg',
      statisticsLaborScreeningsByOrg: 'getStatisticsLaborScreeningsByOrg',
      laborScreeningFields: 'getLaborScreeningFields',
      lsDemographicsByTimeError: 'getLaborScreeningDemographicsByTimeError'
    }),
    isManager () {
      return this.userCurrentContext.userMember.isManager
    },
    formattedLaborScreeningsByOrg () {
      if (
        !this.statisticsLaborScreeningsByOrg ||
        !this.statisticsLaborScreeningsByOrg.length
      ) {
        return []
      }

      return this.statisticsLaborScreeningsByOrg.map((ls) => {
        return _.pick(ls, ['Time', 'Org', 'Location', 'Program', 'Total Screenings', 'Not Enough Info', 'Level 1: Concern', 'Level 2: Indicated'])
      })
    },
    formattedScreeningsByOrg () {
      if (
        !this.statisticsScreeningsByOrg ||
        !this.statisticsScreeningsByOrg.length
      ) {
        return []
      }

      return this.statisticsScreeningsByOrg.map((cseit) => {
        return _.pick(cseit, ['Time', 'Org', 'Location', 'Program', 'Total Screenings', 'No Concern', 'Possible Concern', 'Clear Concern'])
      })
    },
    screeningsByPrimaryOrg () {
      return this.sortScreeningsByOrg('cseit')
    },
    laborScreeningsByPrimaryOrg () {
      return this.sortScreeningsByOrg('laborscreening')
    },
    laborScreeningIndicatorsEnds () {
      return this.lsIndicators.filter(({ field }) => field.startsWith('e_'))
    },
    laborScreeningIndicatorsMeans () {
      return this.lsIndicators.filter(({ field }) => field.startsWith('m_'))
    },
    laborScreeningIndicatorsProcess () {
      return this.lsIndicators.filter(({ field }) => field.startsWith('p_'))
    }
  },
  watch: {
    tabIndex (newValue) {
      if (this.hasVisitedTabMap[newValue]) {
        return
      }

      this.hasVisitedTabMap[newValue] = true
      this.fetchStatsByTab(newValue)
    },
    statisticsTimeInterval: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },
    generalCounts: function (newValue) {
      if (newValue) {
        if (newValue.personCount === 0) {
          this.percentUnconfirmedPersons = 0
          this.percentConfirmedPersons = 0
        } else {
          this.percentUnconfirmedPersons = Math.round(newValue.possiblePersonCount / newValue.personCount * 100)

          if (newValue.confirmedPersonCount === null) {
            this.percentConfirmedPersons = Math.round(0 / newValue.personCount * 100)
          } else {
            this.percentConfirmedPersons = Math.round(newValue.confirmedPersonCount / newValue.personCount * 100)
          }
        }

        if (newValue.cseitCount === 0) {
          this.percentCseitNoconcern = 0
          this.percentCseitPossibleConcern = 0
          this.percentCseitClearConcern = 0
        } else {
          this.percentCseitNoconcern = Math.round(newValue.cseitCountNoConcern / newValue.cseitCount * 100)
          this.percentCseitPossibleConcern = Math.round(newValue.cseitCountPossibleConcern / newValue.cseitCount * 100)
          this.percentCseitClearConcern = Math.round(newValue.cseitCountClearConcern / newValue.cseitCount * 100)
        }

        if (newValue.assessmentCount === 0) {
          this.percentAssessmentNotenoughinfo = 0
          this.percentAssessmentPossible = 0
        } else {
          this.percentAssessmentNotenoughinfo = Math.round(newValue.assessmentCountNotEnoughInfo / newValue.assessmentCount * 100)
          this.percentAssessmentPossible = Math.round(newValue.assessmentCountPossible / newValue.assessmentCount * 100)
        }

        if (newValue.lsCount === 0) {
          this.percentLsNotEnoughInfo = 0
          this.percentLsVulnerable = 0
          this.percentLsHighlyVulnerable = 0
        } else {
          this.percentLsNotEnoughInfo = Math.round(newValue.lsCountNotEnoughInfo / newValue.lsCount * 100)
          this.percentLsVulnerable = Math.round(newValue.lsCountVulnerable / newValue.lsCount * 100)
          this.percentLsHighlyVulnerable = Math.round(newValue.lsCountHighlyVulnerable / newValue.lsCount * 100)
        }
      }
    },
    personsTimeInterval: function () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getPersonCountsByTime', opts)
    },
    cseitTimeInterval: function () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getCseitCountsByTime', opts)
    },
    userCurrentContext: function (newValue) {
      if (newValue) {
        this.fetchStats()
      }
    },
    assessmentsTimeInterval: function () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAssessmentCountsByTime', opts)
    },
    demographicField: function () {
      this.fetchPersonCountsByDemographic()
    },
    cseitDemographicField: function () {
      this.fetchCseitCountsByDemographic()
    },
    laborScreeningDemographicField: function () {
      this.fetchLaborScreeningCountsByDemographic()
    },
    demographicByTimeField: function () {
     this.fetchPersonDemographicsByTime()
    },
    demographicByTimeInterval: function () {
      this.fetchPersonDemographicsByTime()
    },
    assessmentDemographicField: function () {
      this.fetchAssessmentCountsByDemographic()
    },
    assessmentDemographicByTimeField: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentDemographicByTimeInterval: function () {
      this.fetchAssessmentDemographicsByTime()
    },
    assessmentIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.dmst_conclusion = newValue
      }
      this.$store.dispatch('getAssessmentIndicators', opts)
    },
    cseitDemographicByTimeField: function () {
      this.fetchCseitDemographicsByTime()
    },
    lsDemographicByTimeField: function () {
      this.fetchLaborScreeningDemographicsByTime()
    },
    cseitDemographicByTimeInterval: function () {
      this.fetchCseitDemographicsByTime()
    },
    cseitIndicatorOption: function (newValue) {
      const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.calc_cseitScore = newValue
      }
      this.$store.dispatch('getCseitIndicators', opts)
    },
    laborScreeningIndicatorOption: function (newValue) {
       const opts = this.getCommonStatsOpts()
      if (newValue !== 'All') {
        opts.conclusion = newValue
      }
      this.$store.dispatch('getLaborScreeningIndicators', opts)
    }
  },
  data: function () {
    return {
      'someRandomSubsetOfStats': [],
      'assessmentsTimeInterval': 'All',
      'personsTimeInterval': 'All',
      'cseitTimeInterval': 'All',
      'demographicByTimeInterval': 'All',
      'demographicField': 'b_gender_identity',
      'cseitDemographicField': 'b_gender_identity',
      'laborScreeningDemographicField': 'b_gender_identity',
      'assessmentDemographicField': 'b_gender_identity',
      'barDemographicField': 'b_gender_identity',
      'statisticsTimeInterval': 'All',
      'hideMonthGraphFilter': false,
      'hideDayGraphFilter': false,
      'demographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeField': 'b_gender_identity',
      'lsDemographicByTimeField': 'b_gender_identity',
      'assessmentDemographicByTimeField': 'b_gender_identity',
      'cseitDemographicByTimeInterval': 'All',
      'assessmentDemographicByTimeInterval': 'All',
      'assessmentIndicatorsFilter': 'All',
      'assessmentIndicatorOption': 'All',
      'cseitIndicatorOption': 'All',
      'laborScreeningIndicatorOption': 'All',
      'percentUnconfirmedPersons': 0,
      'percentConfirmedPersons': 0,
      'percentCseitNoconcern': 0,
      'percentCseitPossibleConcern': 0,
      'percentCseitClearConcern': 0,
      'percentLsNotEnoughInfo': 0,
      'percentLsVulnerable': 0,
      'percentLsHighlyVulnerable': 0,
      'percentAssessmentNotenoughinfo': 0,
      'percentAssessmentPossible': 0,
      'screeningsTableFields': [
        {
          key: 'Location',
          label: 'Location',
          sortable: true
        },
        {
          key: 'Program',
          label: 'Program',
          sortable: true
        },
        {
          key: 'Total Screenings',
          label: 'Total Screenings',
          sortable: true
        },
        {
          key: 'No Concern',
          label: 'No Concern',
          sortable: true
        },
        {
          key: 'Possible Concern',
          label: 'Possible Concern',
          sortable: true
        },
        {
          key: 'Clear Concern',
          label: 'Clear Concern',
          sortable: true
        }
      ],
      'laborScreeningsTableFields': [
        {
          key: 'Location',
          label: 'Location',
          sortable: true
        },
        {
          key: 'Program',
          label: 'Program',
          sortable: true
        },
        {
          key: 'Total Screenings',
          label: 'Total Screenings',
          sortable: true
        },
        {
          key: 'Not Enough Info',
          label: 'Not Enough Info',
          sortable: true
        },
        {
          key: 'Level 1: Concern',
          label: 'Level 1: Concern',
          sortable: true
        },
        {
          key: 'Level 2: Indicated',
          label: 'Level 2: Indicated',
          sortable: true
        }
      ],
      'customDateRange': {
        'startDate': moment(new Date()).format('ll'),
        'endDate': moment(new Date()).format('ll')
      },
      'timezone': moment.tz.guess(),
      'totalScreeningRow': null,
      'totalLaborScreeningRow': null,
      tabIndex: 0,
      hasVisitedTabMap: {
        [STATISTICS_TAB_INDEX.DEMOGRAPHICS]: false,
        [STATISTICS_TAB_INDEX.CSEIT]: false,
        [STATISTICS_TAB_INDEX.ASSESSMENT]: false,
        [STATISTICS_TAB_INDEX.LABOR_SCREENING]: false
      }
    }
  },
  methods: {
    handleSelect (customDateRange) {
      this.formatDateRange(customDateRange)
    },

    formatDateRange (customDateRange) {
      this.customDateRange.startDate = moment(customDateRange.startDate).format('ll')
      this.customDateRange.endDate = moment(customDateRange.endDate).format('ll')
    },

    saveCustomDateRange (clickApply) {
      clickApply()
      this.formatDateRange(this.customDateRange)
      if (this.statisticsTimeInterval !== 'Custom') {
        this.statisticsTimeInterval = 'Custom'
      } else {
        this.fetchStats()
      }
    },

    initHasVisitedTabMap () {
      // TODO
      Object.values(STATISTICS_TAB_INDEX).map((tabIndex) => {
        this.hasVisitedTabMap[tabIndex] = false
      })
    },

    fetchStats () {
      this.initHasVisitedTabMap()
      this.fetchGeneralCounts()
      this.fetchStatsByTab(this.tabIndex)
    },

    fetchStatsByTab (tabIndex) {
      switch (tabIndex) {
        case STATISTICS_TAB_INDEX.DEMOGRAPHICS:
          this.fetchDemographicsStats()
          break
        case STATISTICS_TAB_INDEX.CSEIT:
          this.fetchCseitStats()
          break
        case STATISTICS_TAB_INDEX.ASSESSMENT:
          this.fetchAssessmentStats()
          break
        case STATISTICS_TAB_INDEX.LABOR_SCREENING:
          this.fetchLaborScreeningStats()
          break
      }
    },

    fetchDemographicsStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getPersonCountsByTime', opts)
      this.fetchPersonCountsByDemographic()
      this.fetchPersonDemographicsByTime()
    },

    fetchCseitStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getCseitCountsByTime', opts)
      this.$store.dispatch('getCseitIndicators', opts)
      if (this.userCurrentContext.userMember.isManager) {
        this.$store.dispatch('getStatisticsScreeningsByOrg', opts)
      }
      this.fetchCseitCountsByDemographic()
      this.fetchCseitDemographicsByTime()
    },

    fetchAssessmentStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAssessmentCountsByTime', opts)
      this.$store.dispatch('getAssessmentIndicators', opts)
      this.fetchAssessmentCountsByDemographic()
      this.fetchAssessmentDemographicsByTime()
    },

    fetchLaborScreeningStats () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getLaborScreeningCountsByTime', opts)
      this.$store.dispatch('getLaborScreeningIndicators', opts)

      if (this.userCurrentContext.userMember.isManager) {
        this.$store.dispatch('getStatisticsLaborScreeningsByOrg', opts)
      }

      this.fetchLaborScreeningCountsByDemographic()
      this.fetchLaborScreeningDemographicsByTime()
    },

    getCommonStatsOpts () {
      const startDate = new Date(this.customDateRange.startDate)
      const endDate = new Date(this.customDateRange.endDate)
      startDate.setHours(0, 0, 0, 0)
      endDate.setHours(23, 59, 59, 999)

      return {
        timeInterval: this.statisticsTimeInterval,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        timezone: this.timezone
      }
    },

    fetchGeneralCounts () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getGeneralCounts', opts)
    },

    fetchPersonCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getPersonCountsByDemographic', Object.assign(opts, {
        demographic: this.demographicField
      }))
    },
    fetchAssessmentCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getAssessmentCountsByDemographic', Object.assign(opts, {
        demographic: this.assessmentDemographicField
      }))
    },
    fetchCseitCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getCseitCountsByDemographic', Object.assign(opts, {
        demographic: this.cseitDemographicField
      }))
    },
    fetchLaborScreeningCountsByDemographic () {
      const opts = this.getCommonStatsOpts()
      this.$store.dispatch('getLaborScreeningCountsByDemographic', Object.assign(opts, {
        demographic: this.laborScreeningDemographicField
      }))
    },
    fetchPersonDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.demographicByTimeField
      this.$store.dispatch('getPersonDemographicsByTime', opts)
      this.$store.dispatch('getPersonDemographicsByTimeUnconfirmed', Object.assign(opts, {
        b_confirmed: 'No'
      }))
      this.$store.dispatch('getPersonDemographicsByTimeConfirmed', Object.assign(opts, {
        b_confirmed: 'Yes'
      }))
    },
    fetchAssessmentDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.assessmentDemographicByTimeField
      this.$store.dispatch('getAssessmentDemographicsByTime', opts)
      this.$store.dispatch('getAssessmentDemographicsByTimeNoInfoVictims', Object.assign(opts, {
        dmst_conclusion: 'No'
      }))
      this.$store.dispatch('getAssessmentDemographicsByTimePossibleVictims', Object.assign(opts, {
        dmst_conclusion: 'Yes'
      }))
    },
    fetchCseitDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.cseitDemographicByTimeField
      this.$store.dispatch('getCseitDemographicsByTime', opts)
      this.$store.dispatch('getCseitDemographicsByTimeNoConcern', Object.assign(opts, {
        calc_cseitScore: 'No Concern'
      }))
      this.$store.dispatch('getCseitDemographicsByTimePossibleConcern', Object.assign(opts, {
        calc_cseitScore: 'Possible Concern'
      }))
      this.$store.dispatch('getCseitDemographicsByTimeClearConcern', Object.assign(opts, {
        calc_cseitScore: 'Clear Concern'
      }))
    },
    fetchLaborScreeningDemographicsByTime () {
      const opts = this.getCommonStatsOpts()
      opts.demographic = this.lsDemographicByTimeField
      this.$store.dispatch('getLaborScreeningDemographicsByTime', opts)
    },
    goToConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'Yes'
        }
      })
    },
    goToBlankConfirmed () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'b_confirmed': 'No'
        }
      })
    },
    goToNotEnoughInfo () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': '0'
        }
      })
    },
    goToPossible () {
      // Not Used Lighthouse Indicators or latest assessment result removed from dashboard.
      this.$router.push({
        path: '/dashboard',
        query: {
          'dmst_conclusion': 'Yes'
        }
      })
    },
    goToNoConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'No Concern'
        }
      })
    },
    goToPossibleConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Possible Concern'
        }
      })
    },
    goToClearConcern () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'cseit_conclusion': 'Clear Concern'
        }
      })
    },
    goToLSNotEnoughInfo () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.NOT_ENOUGH_INFO
        }
      })
    },
    goToLSVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL1
        }
      })
    },
    goToLSHighlyVulnerable () {
      this.$router.push({
        path: '/dashboard',
        query: {
          'ls_conclusion': LABOR_SCREENING_CONCLUSION.LEVEL2
        }
      })
    },
    sortScreeningsByOrg (screeningType) {
      const fieldName = screeningType === 'cseit' ? 'statisticsScreeningsByOrg' : 'statisticsLaborScreeningsByOrg'
      const totalScreeningRowFieldName = screeningType === 'cseit' ? 'totalScreeningRow' : 'totalLaborScreeningRow'
      if (
        !this[fieldName] ||
        !this[fieldName].length
      ) {
        this[totalScreeningRowFieldName] = null
        return []
      }

      let primaryOrgScreenings = this[fieldName].filter((screening) => {
        if (
          screening['OrgId'] !== (
            this.userCurrentContext.organization &&
            this.userCurrentContext.organization.id
          )
        ) {
          return false
        }

        if (!screening['Location'] && !screening['Program']) {
          this[totalScreeningRowFieldName] = screening
          this[totalScreeningRowFieldName]['Location'] = 'Total'
          return false
        }

        return true
      })

      primaryOrgScreenings = _.sortBy(primaryOrgScreenings, ['Location', 'Program'])
      primaryOrgScreenings.sort((a, b) => {
        if (a['Location'] === 'none selected' && a['Program'] === 'none selected') {
          return 1
        } else if (b['Location'] === 'none selected' && b['Program'] === 'none selected') {
          return -1
        }

        const aLoc = a['Location'] === 'none selected' ? '' : a['Location']
        const bLoc = b['Location'] === 'none selected' ? '' : b['Location']

        const aProgram = a['Program'] === 'none selected' ? '' : a['Program']
        const bProgram = b['Program'] === 'none selected' ? '' : b['Program']

        if (!aLoc && !aProgram) {
          return 1
        }

        if (!bLoc && !bProgram) {
          return 1
        }

        if (aLoc || bLoc) {
          const locCompareValue = aLoc.localeCompare(bLoc)
          if (locCompareValue !== 0) {
            return locCompareValue
          }
        }

        if (aProgram || bProgram) {
          const programCompareValue = aProgram.localeCompare(bProgram)
          return programCompareValue
        }

        return 0
      })
      return primaryOrgScreenings
    },
    _getLaborScreeningQuestionBasedOnPrefix (key) {
      if (key.endsWith('otherText')) {
        switch (key) {
          case 'e_fl_otherText':
            return 'Forced Labor - Other'
          case 'e_db_otherText':
            return 'Debt Bondage - Other'
          case 'm_c_otherText':
            return 'Coercion - Other'
          case 'm_fr_otherText':
            return 'Fraud - Other'
          case 'm_fo_otherText':
            return 'Force - Other'
          case 'p_otherText':
            return 'Process - Other'
        }
      }

      switch (true) {
        case key.startsWith('e_fl_'):
          return this.laborScreeningFields.ENDS.FORCED_LABOR[key].label
        case key.startsWith('e_db_'):
          return this.laborScreeningFields.ENDS.DEBT_BONDAGE[key].label
        case key.startsWith('m_c_'):
          return this.laborScreeningFields.MEANS.COERCION[key].label
        case key.startsWith('m_fr_'):
          return this.laborScreeningFields.MEANS.FRAUD[key].label
        case key.startsWith('m_fo_'):
          return this.laborScreeningFields.MEANS.FORCE[key].label
        case key.startsWith('p_'):
          return this.laborScreeningFields.PROCESS[key].label
      }
    },
    transformLaborScreeningIndicatorKey (key) {
      return this._getLaborScreeningQuestionBasedOnPrefix(key)
    }
  },
  mounted () {
    this.fetchStats()
    this.hasVisitedTabMap[STATISTICS_TAB_INDEX.DEMOGRAPHICS] = true
  }
}
</script>
<style>
  #statistics-tabs{
    margin-bottom: 50px;
  }
  .clickable-card{
    cursor: pointer;
  }
  .col-sm-6 canvas {
    margin: auto;
  }
  .reportrange-text.form-control {
    padding: 0 !important;
    border: none !important;
    overflow: auto !important;
    height: auto !important;
  }
  .date-range-picker__footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    box-sizing: border-box;
  }

  .calendars {
    justify-content: center;
  }

  .date-range-picker__header {
    display: flex;
    padding: 0 5px 10px;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #f2f2f2;
    gap: 5px;
  }

  .date-range-picker__header label {
    margin-bottom: 0;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/Statistics.vue